import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './components/app';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ColorModeSelector } from '@lib/theme/theme-switch';
import { appStart } from './redux/actions/app-actions';

const root = createRoot(document.getElementById('root') as HTMLElement);

async function app() {
  store.dispatch(appStart());

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ColorModeSelector>
          <App />
        </ColorModeSelector>
      </Provider>
    </React.StrictMode>
  );
}

app();
